// src/components/customer/blog/BlogShareSection.jsx
import React from 'react';
import { Button } from 'react-bootstrap';
import { FiFacebook, FiTwitter, FiLinkedin, FiMail, FiShare2 } from 'react-icons/fi';
import '../../../assets/css/customer/subscreens/blog/BlogShareSection.css';

const BlogShareSection = ({ title, url }) => {
  const handleShare = (platform) => {
    // Add your share logic here
    console.log(`Sharing on ${platform}`);
  };

  return (
    <div className="blog-share-section">
      <span className="share-label">SHARE:</span>
      <div className="share-icons-wrapper">
        <Button 
          variant="outline-secondary" 
          className="share-icon-btn"
          onClick={() => handleShare('facebook')}
        >
          <FiFacebook size={16} />
        </Button>
        <Button 
          variant="outline-secondary" 
          className="share-icon-btn"
          onClick={() => handleShare('twitter')}
        >
          <FiTwitter size={16} />
        </Button>
        <Button 
          variant="outline-secondary" 
          className="share-icon-btn"
          onClick={() => handleShare('linkedin')}
        >
          <FiLinkedin size={16} />
        </Button>
        <Button 
          variant="outline-secondary" 
          className="share-icon-btn"
          onClick={() => handleShare('email')}
        >
          <FiMail size={16} />
        </Button>
        <Button 
          variant="outline-secondary" 
          className="share-icon-btn"
          onClick={() => handleShare('copy')}
        >
          <FiShare2 size={16} />
        </Button>
      </div>
    </div>
  );
};

export default BlogShareSection;